"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("./helpers");

var _styles = _interopRequireDefault(require("./styles"));

var _Search$propTypes;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SearchContainer = _styles["default"].SearchContainer,
    SearchStyle = _styles["default"].SearchStyle;

var Search = function Search(props) {
  var _React$createElement;

  var height = props.height,
      width = props.width,
      placeholder = props.placeholder,
      disabled = props.disabled,
      _onChange = props.onChange,
      onError = props.onError,
      onSubmit = props.onSubmit,
      className = props.className,
      clearValue = props.clearValue;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  (0, _react.useEffect)(function () {
    setLoaded(true);
  }, []);
  (0, _react.useEffect)(function () {
    if (loaded) {
      setValue(props.value);

      if (props.value) {
        (0, _helpers.activateAnimation)(props.value);
      } else {
        (0, _helpers.clearAnimation)();
      }
    }
  }, [props.value]);
  (0, _react.useEffect)(function () {
    if (loaded && clearValue) (0, _helpers.handleClear)({
      setValue: setValue,
      onSubmit: onSubmit
    });
  }, [clearValue]);
  return /*#__PURE__*/_react["default"].createElement(SearchContainer, {
    className: className,
    height: height,
    width: width,
    value: value
  }, /*#__PURE__*/_react["default"].createElement(SearchStyle, (_React$createElement = {
    className: "search-input",
    placeholder: placeholder,
    value: value,
    onChange: _onChange,
    onError: onError,
    disabled: disabled,
    rounded: true,
    optional: true
  }, _defineProperty(_React$createElement, "onChange", function onChange(e) {
    _onChange ? _onChange(e) : (0, _helpers.handleChange)(e, {
      value: value,
      setValue: setValue
    });

    if (_.has(props, 'source') && !_.isNil(props.source) && _.has(props, 'filterBy') && !_.isNil(props.filterBy)) {
      var _final = (0, _helpers.filterItems)({
        source: props.source,
        keys: props.filterBy,
        value: e.target.value
      });

      if (props.filtered) {
        props.filtered(_final);
      }
    }
  }), _defineProperty(_React$createElement, "onFocus", function onFocus() {
    return (0, _helpers.handleFocus)({
      value: value
    });
  }), _defineProperty(_React$createElement, "onBlur", function onBlur() {
    return (0, _helpers.handleBlur)({
      value: value,
      onSubmit: onSubmit
    });
  }), _defineProperty(_React$createElement, "onKeyDown", function onKeyDown(e) {
    return (0, _helpers.handleKeyDown)(e, {
      value: value,
      onSubmit: onSubmit
    });
  }), _React$createElement)), /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon search-icon far fa-search",
    onClick: function onClick() {
      return onSubmit(value);
    }
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon clear-icon far fa-times",
    onClick: function onClick() {
      return (0, _helpers.handleClear)({
        setValue: setValue,
        onSubmit: onSubmit
      });
    }
  }));
};

Search.propTypes = (_Search$propTypes = {
  className: _propTypes["default"].string,
  height: _propTypes["default"].string,
  width: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func.isRequired
}, _defineProperty(_Search$propTypes, "className", _propTypes["default"].string), _defineProperty(_Search$propTypes, "value", _propTypes["default"].string.isRequired), _defineProperty(_Search$propTypes, "clearValue", _propTypes["default"].bool), _defineProperty(_Search$propTypes, "filterBy", _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].arrayOf(_propTypes["default"].object)])), _defineProperty(_Search$propTypes, "source", _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].arrayOf(_propTypes["default"].object)])), _Search$propTypes);
var _default = Search;
exports["default"] = _default;